import { c as _c } from "react/compiler-runtime";
import { H3TextBlock } from '@/uiComposites/typography/headings';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { ResultCategorisationRendered, ResultRendered } from '@/app/decisionToolArticle/_data/decisionToolRendered.types';
import { Fragment, useState } from 'react';
import { ResultsHeading } from './ResultsHeading';
import { NoResults } from './NoResults';
import { stack } from '@/uiPrimitives/layout/stack';
import { ResultList, ResultListItem } from './ResultList';
import { rows } from '@/uiPrimitives/layout/rows';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { textBlock } from '@/uiPrimitives/typography/text';
import { translateInline } from '@/globals/translate/translateInline';
import { hidden, hiddenWhenParentIsLastChild } from '@/uiPrimitives/utility/display.css';
import { interactive } from '@/uiPrimitives/interactive/interactive';
import { getFilteredResultCategorisations } from '../_data/filterResults';
import { pushSortResultsEvent } from '@/globals/analytics/events/pushDecisionToolEvent';
import { convertGivenAnswersToSearchParams, useGivenAnswers } from '../_data/useGivenAnswers';
import { Sharesheet } from '@/sections/sharesheet/Sharesheet';
import { AnyRenderedQuestion } from '../_questions/question.types';
import { sharesheetButtonTranslations } from '@/sections/sharesheet/sharesheetTranslations';
import { AccordionToggleButtons } from '@/uiComposites/interactive/accordion/AccordionToggleButtons.client';
import { accordionToggleButtons } from './Results.css';
import { AccordionProviderPersisted } from '@/uiComposites/interactive/accordion/AccordionProvider.client';
import { viewTransitionName } from '@/uiPrimitives/utility/viewTransitionNames.css';
export const CategorisedResults = t0 => {
  const $ = _c(18);
  const {
    resultCategorisations,
    relevantResults,
    questions,
    pageTitle
  } = t0;
  const relevantResultIds = relevantResults.map(_temp);
  const filteredResultCategorisations = getFilteredResultCategorisations(resultCategorisations, relevantResultIds);
  const [activeCategorisationId, setActiveCategorisationId] = useState(filteredResultCategorisations[0]?.id);
  const [givenAnswers] = useGivenAnswers(questions);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(stack({
      rowGap: "9 | asideBlockMargin"
    }), viewTransitionName({
      viewTransitionName: "decision-tool-result"
    }));
    t2 = <ResultsHeading />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = filteredResultCategorisations.length > 1 && <div className={classes(rows({
    columnGap: "0 | p",
    rowGap: "2 | h2"
  }))}><p className={classes(textBlock({}))}>{translateInline({
        en: "Sort by:",
        nl: "Sorteer op:"
      })}</p><ul className={classes(rows({
      columnGap: "inherit",
      rowGap: "inherit"
    }))}>{filteredResultCategorisations.map(resultCategorisation => {
        const isActive = resultCategorisation.id === activeCategorisationId;
        return <li key={resultCategorisation.id} className={classes(shelf({
          columnGap: "inherit"
        }))}><button onClick={() => {
            setActiveCategorisationId(resultCategorisation.id);
            pushSortResultsEvent({
              categorisationTitle: resultCategorisation.titleText,
              givenAnswersSearchParamsString: convertGivenAnswersToSearchParams(givenAnswers, questions).toString()
            });
          }} aria-expanded={isActive} aria-controls={`id-${resultCategorisation.id}`} className={classes(isActive && interactive({
            cursor: "default"
          }), textBlock(isActive ? {
            fontWeight: "bold",
            color: "positive:noHover"
          } : {
            color: "positiveBlue"
          }))}>{resultCategorisation.title}</button><span className={classes(textBlock({}), hiddenWhenParentIsLastChild)} aria-hidden={true}>{"/"}</span></li>;
      })}</ul></div>;
  const t4 = filteredResultCategorisations.length === 0 && <NoResults />;
  let t5;
  if ($[2] !== activeCategorisationId || $[3] !== givenAnswers || $[4] !== questions || $[5] !== relevantResults) {
    t5 = t6 => {
      const {
        categories,
        id
      } = t6;
      const totalLength_0 = categories.reduce(_temp2, 0);
      if (totalLength_0 === 0) {
        return <NoResults key={id} />;
      }
      return <div key={id} id={`id-${id}`}><div className={classes(stack({
          rowGap: "7 | betweenH3Sections"
        }), id !== activeCategorisationId && hidden)}>{categories.map(category_0 => {
            if (category_0.resultIds.length === 0) {
              return null;
            }
            const firstAccordionIndex = category_0.resultIds.findIndex(resultId => {
              const result_1 = relevantResults.find(result_0 => result_0.id === resultId);
              return result_1?.type === "accordion";
            });
            return <AccordionProviderPersisted accordionKey={`CategorisedResults-${category_0.id}`} key={category_0.id}><section className={classes(stack({
                rowGap: "3 | h1"
              }))}><H3TextBlock>{category_0.title}</H3TextBlock><ResultList allQuestions={questions} givenAnswers={givenAnswers}>{category_0.resultIds.map((resultId_0, index) => {
                    const result_3 = relevantResults.find(result_2 => result_2.id === resultId_0);
                    if (result_3 == null) {
                      return null;
                    }
                    return <Fragment key={resultId_0}>{firstAccordionIndex === index && <div className={classes(stack({}), accordionToggleButtons)}><AccordionToggleButtons itemsCount={category_0.resultIds.filter(resultId_1 => {
                          const result_5 = relevantResults.find(result_4 => result_4.id === resultId_1);
                          return result_5?.type === "accordion";
                        }).length} /></div>}<ResultListItem result={result_3} headingLevel="h4" /></Fragment>;
                  })}</ResultList></section></AccordionProviderPersisted>;
          })}</div></div>;
    };
    $[2] = activeCategorisationId;
    $[3] = givenAnswers;
    $[4] = questions;
    $[5] = relevantResults;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = filteredResultCategorisations.map(t5);
  let t7;
  if ($[7] !== t4 || $[8] !== t6) {
    t7 = <div>{t4}{t6}</div>;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== pageTitle) {
    t8 = <Sharesheet buttonLabel={sharesheetButtonTranslations["Share results"]} pageTitle={pageTitle} />;
    $[10] = pageTitle;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t7 || $[16] !== t8) {
    t9 = <article className={t1}>{t2}{t3}{t7}{t8}</article>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
function _temp(result) {
  return result.id;
}
function _temp2(totalLength, category) {
  return totalLength + category.resultIds.length;
}